import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/outsideEea/user.outsideEea.query.gql"
import type {
  UserOutsideEeaQuery,
  UserOutsideEeaQueryVariables,
} from "@/v2-backoffice-client/user/outsideEea/__types__/user.outsideEea.query"

type Options = QueryHookOptions<
  UserOutsideEeaQuery,
  UserOutsideEeaQueryVariables
>

export function useUserOutsideEeaQuery(options?: Options) {
  return useQuery<UserOutsideEeaQuery, UserOutsideEeaQueryVariables>(
    query,
    options,
  )
}
